const errorMessages: { [key: string]: string } = {
  '413': 'El archivo es demasiado grande.',
};
export default errorMessages;
